import React, { memo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { toggleModal } from "../../redux/actions";
import { Hamburger, Cross } from "../../utils";
import Navigation from '../Navigation';
import Logotype from '../Logotype';
import { WeatherWidget } from "../../containers";
import { HeaderTag, HeaderContainer, ToggleButton } from "./styles";

const Header = ({ handleMenuToggleClick, openedModal, isInnerPage, simplified, checkout, fixed }) => {
  if (simplified) {
    return (
      <HeaderTag>
        <HeaderContainer>
          <Logotype innerPage={isInnerPage} />
          <WeatherWidget showCity />
        </HeaderContainer>
      </HeaderTag>
    )
  }

  return (
    <HeaderTag fixed={fixed} isInnerPage={isInnerPage} isOpen={openedModal === 'navigation'}>
      <HeaderContainer>
        <Logotype innerPage={isInnerPage} />
        {!isInnerPage && <WeatherWidget />}
        {!checkout && (
          <Fragment>
            <Navigation isOpen={openedModal === 'navigation'} isInnerPage={isInnerPage} />
            <ToggleButton onClick={() => handleMenuToggleClick('navigation')}>
              {openedModal === 'navigation' ? <Cross color="#ffffff" width={24} height={16} /> : <Hamburger width={24} height={14} />}
            </ToggleButton>
          </Fragment>
        )}
      </HeaderContainer>
    </HeaderTag>
  )
} ;

Header.propTypes = {
  handleMenuToggleClick: PropTypes.func,
  openedModal: PropTypes.string,
  isInnerPage: PropTypes.bool,
  simplified: PropTypes.bool,
  checkout: PropTypes.bool,
  fixed: PropTypes.bool,
};

const mapStateToProps = state => ({
  openedModal: state.ui.openedModal,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleMenuToggleClick: toggleModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(memo(Header));
